import { Link, useLocation, Outlet } from 'react-router';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarTrigger
} from '@/components/ui/sidebar';
import { menuItems } from '@/config/menu.config';
import { SidebarUserMenu } from './sidebar-user-menu';

export function AppShell() {
  const location = useLocation();
  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <SidebarProvider defaultOpen={false}>
      <Sidebar collapsible='icon'>
        <SidebarHeader>
          <Link to='/accounts'>
            <div className='flex shrink-0 items-center justify-center rounded-lg'>
              <img
                src='/assets/brand/kim-ai-logo.svg'
                className='h-9 w-9'
                alt='Kim'
              />
            </div>
          </Link>
        </SidebarHeader>
        <SidebarContent>
          <SidebarMenu>
            {menuItems.map((item) => (
              <SidebarMenuItem key={item.path}>
                <SidebarMenuButton
                  asChild
                  tooltip={item.label}
                  isActive={isActive(item.path)}
                >
                  <Link to={item.path}>
                    <item.icon />
                    <span>{item.label}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarContent>
        <SidebarFooter className='px-0 pb-3'>
          <SidebarUserMenu />
        </SidebarFooter>
      </Sidebar>
      <SidebarInset>
        <header className='sticky top-0 z-10 flex h-14 shrink-0 items-center gap-3 border-b bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/60'>
          <SidebarTrigger className='-ml-1' />
          <div className='h-4 w-px bg-border' />
          <span className='text-sm font-semibold'>Kim Control Panel</span>
        </header>
        <div className='flex flex-1 flex-col overflow-auto'>
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
